// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { qtyFieldStyles } from "@guestsupply/App/Components/Qty/QtyField";
import cartLineSharedStyles from "@guestsupply/App/SharedStyles/CartLineSharedStyles";
import { createProductDescriptionStyles } from "@guestsupply/App/SharedStyles/productDescriptionStyles";
import { createHorizontalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { cartLineCardExpandedStyles } from "@guestsupply/Overrides/Widgets/Cart/CartLineCardExpanded";
import FreightCharges from "@guestsupply/XDL/Icons/FreightCharges";
import Plus from "@guestsupply/XDL/Icons/Plus";
import Trash from "@guestsupply/XDL/Icons/Trash";
import { color, createLinkIconStyles, mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import { StyledButton } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import Truck from "@insite/mobius/Icons/Truck";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cartLineCardExpandedStyles.container = {
    gap: 20,
    css: css`
        border-bottom: 1px solid ${getColor("common.border")};
        padding: 1rem 0;
    `,
};
cartLineCardExpandedStyles.productImageGridItem = {
    width: 2,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    font-size: 10px;
                `,
                css`
                    font-size: 10px;
                `,
                css`
                    font-size: 10px;
                `,
                css`
                    font-size: 10px;
                `,
                null,
            ])}
    `,
};
cartLineCardExpandedStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};
cartLineCardExpandedStyles.cartLineInfoGridItem = { width: [8, 8, 8, 9, 9] };
cartLineCardExpandedStyles.cartLineInfoContainer = { gap: 20 };
cartLineCardExpandedStyles.productInfoGridItem = { width: [12, 12, 12, 7, 7] };
cartLineCardExpandedStyles.productInfoContainer = { gap: 12 };
cartLineCardExpandedStyles.productBrandAndDescriptionGridItem = {
    css: css`
        flex-direction: column;
    `,
    width: 12,
};
cartLineCardExpandedStyles.productDescriptionGridItem = {
    width: 12,
};
cartLineCardExpandedStyles.configurationGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};
cartLineCardExpandedStyles.productPartNumbersGridItem = { width: 12 };
cartLineCardExpandedStyles.quantityAndExtendedUnitNetPriceGridItem = { width: 12 };
cartLineCardExpandedStyles.quantityGridItem = { width: 6 };
cartLineCardExpandedStyles.extendedUnitNetPriceGridItem = {
    width: 6,
    css: css`
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-end;
    `,
};
cartLineCardExpandedStyles.extendedUnitNetPriceText = {
    weight: "bold",
    size: 16,
    css: css`
        text-align: start;
        display: flex;
    `,
};
cartLineCardExpandedStyles.vatLabelText = {
    size: 12,
};
cartLineCardExpandedStyles.subtotalWithoutVatText = {
    weight: "bold",
    css: css`
        margin-top: 5px;
    `,
};
cartLineCardExpandedStyles.cartLineErrorMessageGridItem = { ...cartLineSharedStyles.cartLineErrorMessageGridItem };
cartLineCardExpandedStyles.cartLineErrorMessageText = { color: "danger" };
cartLineCardExpandedStyles.productPriceAndAvailabilityGridItem = {
    width: [12, 12, 12, 5, 5],
    css: css`
        flex-direction: column;
    `,
};
cartLineCardExpandedStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
};
cartLineCardExpandedStyles.addToListLink = {
    ...cartLineSharedStyles.addToListLink,
};
cartLineCardExpandedStyles.deliveryScheduleButton = {
    css: css`
        margin-top: 20px;
    `,
};
cartLineCardExpandedStyles.costCodeGridItem = {
    ...cartLineSharedStyles.costCodeGridItem,
};
cartLineCardExpandedStyles.costCodeLabelText = {
    ...cartLineSharedStyles.costCodeLabelText,
};
cartLineCardExpandedStyles.cartLineNotesGridItem = { width: 12 };
cartLineCardExpandedStyles.cartLineNotes = {
    ...cartLineSharedStyles.cartLineNotes,
};
cartLineCardExpandedStyles.removeCartLineGridItem = {
    css: css`
        justify-content: center;
    `,
    width: [2, 2, 2, 1, 1],
};
cartLineCardExpandedStyles.removeCartLineIcon = { ...cartLineSharedStyles.removeCartLineIcon };
cartLineCardExpandedStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};
cartLineCardExpandedStyles.smallHeadingStyle = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                height: 18px;
                margin-bottom: 4px;
                margin-right: 8px;
                width: auto;
                @media print {
                    display: flex;
                }
            `,
        },
        heading: {
            weight: "bold",
        },
    }),
};
cartLineCardExpandedStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};
cartLineCardExpandedStyles.productAvailability = {
    ...cartLineSharedStyles.productAvailability,
};
cartLineCardExpandedStyles.lineContainerStyles = {
    ...mergeWithCss(cartLineSharedStyles.lineContainerStyles, {
        description: {
            css: css`
                @media print {
                    margin-bottom: 4px;
                }
            `,
        },
    }),
};
cartLineCardExpandedStyles.notify = {
    ...cartLineSharedStyles.notify,
};

cartLineCardExpandedStyles.surchargesTooltip = {
    ...cartLineSharedStyles.surchargesTooltip,
};
cartLineCardExpandedStyles.totalFreightChargesLink = {
    ...cartLineSharedStyles.totalFreightChargesLink,
};
cartLineCardExpandedStyles.headlineTypography = {
    ...cartLineSharedStyles.headlineTypography,
};
cartLineCardExpandedStyles.pricingFailedStyle = {
    ...cartLineSharedStyles.pricingFailedStyle,
};

cartLineCardExpandedStyles.configurationOptionText = {
    ...cartLineSharedStyles.configurationOptionText,
};

cartLineCardExpandedStyles.promotionNameText = {
    ...cartLineSharedStyles.promotionNameText,
};

cartLineCardExpandedStyles.quantity = {
    readOnlyQuantityText: {
        extendedStyles: {
            heading: {
                ...mergeWithCss(qtyFieldStyles.qtyLabel, {
                    as: "label",
                    size: 12,
                    weight: "normal",
                    lineHeight: "13px",
                    css: css`
                        margin-bottom: 4px;
                        display: none;
                        text-transform: capitalize;
                        ${xScreen("lte", "md")} {
                            display: block;
                            padding-bottom: 7px;
                        }
                    `,
                }),
            },
            text: {
                ...mergeWithCss(qtyFieldStyles.valueText, {
                    size: 16,
                    weight: "bold",
                    lineHeight: "17px",
                    css: css`
                        text-align: start;
                        display: flex;
                        line-height: 17px;
                    `,
                }),
            },
        },
    },
};

cartLineCardExpandedStyles.altDcLink = {
    ...createLinkIconStyles(Truck, {
        typographyProps: {
            size: 12,
            weight: "bold",
            lineHeight: 12,
        },
        icon: {
            iconProps: {
                size: 12,
                color: "text.link",
                css: css`
                    &&&&& {
                        margin-right: 6px;
                    }
                `,
            },
            position: "left",
        },
        css: css`
            &&& {
                display: flex;
            }
            margin-top: 4px;
        `,
    }),
};

cartLineCardExpandedStyles.tooltipStyle = {
    cssOverrides: {
        tooltipContainer: css`
            max-width: 300px;
            width: 300px;
            ${xScreen("lte", "md")} {
                max-width: 260px;
            }
        `,
        tooltipClickable: css`
            display: flex;
            margin: 0 0 0 2px;
        `,
    },
};

cartLineCardExpandedStyles.productImageBadgesStyle = {
    container: {
        css: css`
            margin-bottom: 8px;
        `,
    },
};
